// Central SEO copy. The data itself lives in seo.json rather than here
// because scripts/prerender.js has to read the same table from plain Node at
// build time: it writes the per-URL <title>, description and canonical into
// the HTML a crawler gets before any JavaScript runs, and those have to say
// exactly what <Seo> will say once React mounts.
import seo from 'constants/seo.json';

export const SITE_NAME = seo.siteName;
export const SITE_FULL_NAME = seo.siteFullName;
export const SITE_URL = seo.siteUrl;
export const DEFAULT_TITLE = `${SITE_NAME} — ${SITE_FULL_NAME}`;
export const DEFAULT_DESCRIPTION = seo.defaultDescription;
// Square ECDS mark — not the ideal 1200x630 social-preview crop, but it's the
// only brand asset in public/ today and beats no image at all. Swap this for
// a proper wide banner if/when one exists.
export const DEFAULT_OG_IMAGE = seo.defaultOgImage;

// The props <Seo> takes for a fixed page, by pathname. Anything else in the
// table (the fallback heading, sitemap hints) is for the prerenderer and is
// deliberately not spread into the component.
export const pageSeo = (pathname) => {
  const page = seo.pages[pathname] ?? {};

  return {
    title: page.title,
    description: page.description,
    noindex: page.noindex,
    ...(page.canonical ? { path: page.canonical } : {}),
  };
};
